module.exports = __webpack_public_path__ + "assets/img/ds-popup-btn.86fe19fb.png";